import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { getRecoil } from "recoil-nexus";
import styled from "styled-components";
import CustomerInfoModal from "../../../components/modal/CustomerInfoModal";
import ApiController from "../../../controller/ApiController";
import LogController from "../../../controller/LogController";
import {
  ContentCardDataType,
  ContentCardDetailType,
} from "../../../controller/MasterController";
import { useToast } from "../../../controller/ToastController";
import {
  authState,
  authStoreType,
  masterStoreState,
} from "../../../recoil/auth";
import { langText } from "../../../recoil/lang";
import { getHotelInfoTitle } from "../../../utils/util";

interface StoreCouponProps {
  lang: number;
  cardData: ContentCardDataType | null;
  setVoucherContent: any;
}

const StoreCouponDetailContent = ({
  lang,
  cardData,
  setVoucherContent,
}: StoreCouponProps) => {
  const showToast = useToast();
  const [visibleCustomerInfoModal, setVisibleCustomerInfoModal] =
    useState<boolean>(false);

  const [number, setNumber] = useState<string>("");
  const [email, setEmail] = useState<string>("");

  const [cardDetail, setCardDetail] = useState<ContentCardDetailType | null>(
    null
  );

  const master = useRecoilValue<authStoreType | null>(masterStoreState);

  const successVoucher = (number: any, email: any) => {
    if (number || email) {
      sendVoucher(number, email);
    }
  };

  // API
  // 카드 상세정보 불러오기
  const getCardContent = async (cardId: number) => {
    try {
      const response = await ApiController.store.getCardContent(cardId, lang);

      if (response.ok) {
        setCardDetail(response.data);
      }
    } catch (err) {
      console.log("getCardContent err-->", err);
    }
  };

  const sendVoucher = async (number: string, email: string) => {
    if (cardDetail && master) {
      LogController.click({
        path: "StoreCouponDetailContent",
        params: "coupon",
        params2: cardDetail.voucher.store_name,
        index: cardDetail.voucher.voucher_id,
      });

      const response = await ApiController.store.sendVoucher(
        cardDetail.voucher.voucher_id,
        master.store_id,
        getRecoil(authState).user_token_id,
        number !== "" ? 0 : 1,
        number !== "" ? number : email,
        lang
      );

      if (response.data.success) {
        showToast(langText.send_coupon[lang], "success");
      } else {
        if (response.data.fail_type === 1) {
          showToast(langText.coupon_issued[lang], "error");
        } else if (response.data.fail_type === 2) {
          showToast(langText.coupon_none[lang], "error");
        } else if (response.data.fail_type === 3) {
          showToast(langText.coupon_expired[lang], "error");
        }
      }
      setVisibleCustomerInfoModal(false);
      setNumber("");
      setEmail("");
    }
  };

  useEffect(() => {
    if (cardData?.card_id) {
      getCardContent(cardData.card_id);
    }
  }, [lang, cardData]);

  useEffect(() => {
    if (number !== "" || email !== "") {
      successVoucher(number, email);
    }
  }, [number, email]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVoucherContent(false);
      setVisibleCustomerInfoModal(false);
    }, 5 * 60 * 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Style>
      <div>
        <div className="contentHeader">
          <img
            onClick={() => setVoucherContent(false)}
            className="closeIcon"
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_left.svg`}
            alt="뒤로가기 버튼"
          />
          {cardData && <h2>{getHotelInfoTitle(cardData, lang)}</h2>}
        </div>
        {cardDetail &&
          cardDetail.content_data.map((data, index) => (
            <div>
              {data.url && <img width={"100%"} src={`${data.url}`} />}
              <p>{data.content}</p>
            </div>
          ))}
        {cardDetail && cardDetail.voucher && (
          <button onClick={() => setVisibleCustomerInfoModal(true)}>
            {langText.get_coupon[lang]}
          </button>
        )}
        <CustomerInfoModal
          isVisible={visibleCustomerInfoModal}
          setVisible={setVisibleCustomerInfoModal}
          doPayment={successVoucher}
          setNumber={setNumber}
          setEmail={setEmail}
          mainTitle={langText.coupon_contact_request[lang]}
        />
      </div>
    </Style>
  );
};
export default StoreCouponDetailContent;

const Style = styled.div`
  .contentHeader {
    display: flex;
    align-items: center;
    margin-bottom: 35px;
    img {
      margin: 0;
    }
    h2 {
      flex: 1;
    }
  }
  img {
    width: 100%;
    margin-bottom: 12px;
    object-fit: contain;
  }
  h2 {
    font-size: 24px;
    font-weight: 500;
    text-align: center;
    color: #fff;
  }
  p {
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    line-height: 30px;
  }
  .closeIcon {
    width: 36px;
  }
  button {
    margin-top: 50px;
    width: 100%;
    border-radius: 10px;
    background: #4dd2ae;
    font-size: 24px;
    font-weight: 600;
    color: #fff;
    padding: 17px 0;
  }
`;
